import React, { FC, InputHTMLAttributes } from "react";
import clsx from "clsx";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  ipSize?: "lg" | "md";
  label?: string;
  isError?: boolean;
  errorMessage?: string;
  wrapClassName?: string;
  className?: string;
  iconType?: "stroke" | "fill";
  iconRight?: React.ElementType;
  indeterminate?: boolean;
}

export const Checkbox: FC<Props> = ({
  ipSize = "lg",
  label,
  isError,
  errorMessage,
  className,
  wrapClassName,
  id,
  checked,
  disabled,
  indeterminate = false,
  ...rest
}) => {
  return (
    <div className={clsx("select-none", wrapClassName)}>
      <div className="relative flex items-center">
        <div
          className={clsx(
            "flex items-center h-5",
            !disabled && "cursor-pointer"
          )}
        >
          <input
            {...rest}
            id={id}
            disabled={disabled}
            checked={checked}
            type="checkbox"
            className={clsx(
              "rounded focus:ring-transparent text-blue",
              ipSize === "md" ? "h-4 w-4" : "h-5 w-5",
              isError ? "border-red" : "border-neutral-30",
              disabled ? "!bg-neutral-20" : "cursor-pointer",
              !disabled && "hover:border-blue-dark",
              className
            )}
            ref={(input) => {
              if (input) input.indeterminate = indeterminate;
            }}
          />
        </div>
        {Boolean(label) && (
          <div className="ml-3 text-base">
            <label htmlFor={id} className="text-neutral-70 cursor-pointer">
              {label}
            </label>
          </div>
        )}
      </div>
      {Boolean(errorMessage) && (
        <p className="mt-[0.375rem] text-sm text-red" id="email-error">
          {errorMessage}
        </p>
      )}
    </div>
  );
};
